@if (loading()) {
  <div
    class="loading-container"
    [class.fullscreen]="fullscreen()"
    [style.--loading-bg-color]="bdColor()"
    [style.z-index]="zIndex()"
  >
    @if (customLoading()) {
      <ng-container *ngTemplateOutlet="customLoading()" />
    } @else {
      <dds-spinner
        [customClass]="customClass()"
        [isInverse]="isInverse()"
        [size]="size()"
        [theme]="theme()"
        [thickness]="thickness()"
      />
    }
  </div>
}
